import { capitalize } from "lodash";

export const formatName = (name?: string) => {
  if (!name) return "";
  const nameParts = name.split(" ");
  const formattedName = nameParts.map(p => capitalize(p)).join(" ");
  return formattedName;
};

export const initialName = (name?: string) => {
  if (!name) return "";
  if (name.length === 0) return "";
  return name[0];
};
